export default __webpack_public_path__ + "static/media/Belt of the Spheres.df3477e5.jpg";